var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
import { useSafeRunMutation } from 'utils/mutations';
// VENDOR_SETUP_DELETE_ATTACHMENT
var mutation = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation VendorSetupDeleteAttachment($id: ID!) {\n    vendorSetupDeleteAttachment(id: $id) {\n      id\n      source_attachments {\n        short_url\n        file_url\n        scan_status\n        title\n        notes\n      }\n    }\n  }\n"], ["\n  mutation VendorSetupDeleteAttachment($id: ID!) {\n    vendorSetupDeleteAttachment(id: $id) {\n      id\n      source_attachments {\n        short_url\n        file_url\n        scan_status\n        title\n        notes\n      }\n    }\n  }\n"])));
export default function useVendorSetupDeleteAttachment() {
    var _a = useSafeRunMutation({
        mutation: mutation,
        responsePath: 'vendorSetupDeleteAttachment',
        successMessage: 'Attachment deleted'
    }), onVendorSetupAttachmentDelete = _a.onMutate, loading = _a.loading;
    return { onVendorSetupAttachmentDelete: onVendorSetupAttachmentDelete, loading: loading };
}
var templateObject_1;
